document.addEventListener('DOMContentLoaded', function() {
  let currentSection = 0;
  let isInitialized = false;

  // Function to initialize quiz form handlers
  function initializeQuizForm() {
    // Prevent multiple initializations
    if (isInitialized) {
      return true;
    }

    const form = document.getElementById('custom-quiz-form');
    const sections = document.querySelectorAll('.form-section');
    const progressBar = document.querySelector('.progress');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    const submitBtn = document.getElementById('submitBtn');

    // Check if all required elements exist
    if (!form || !sections.length || !prevBtn || !nextBtn || !submitBtn) {
      // Elements not ready yet, will retry when form is created
      return false;
    }

    function updateButtons() {
      if (prevBtn && nextBtn && submitBtn) {
        prevBtn.style.display = currentSection === 0 ? 'none' : 'block';
        if (currentSection === sections.length - 1) {
          nextBtn.style.display = 'none';
          submitBtn.style.display = 'block';
        } else {
          nextBtn.style.display = 'block';
          submitBtn.style.display = 'none';
        }
      }
    }

    function updateProgress() {
      if (progressBar && sections.length > 0) {
        const progress = ((currentSection + 1) / sections.length) * 100;
        progressBar.style.width = `${progress}%`;
      }
    }

    function showSection(sectionIndex) {
      sections.forEach((section, index) => {
        section.classList.toggle('active', index === sectionIndex);
      });
      updateButtons();
      updateProgress();
    }

    // Add event listeners
    prevBtn.addEventListener('click', () => {
      if (currentSection > 0) {
        currentSection--;
        showSection(currentSection);
      }
    });

    nextBtn.addEventListener('click', () => {
      if (currentSection < sections.length - 1) {
        currentSection++;
        showSection(currentSection);
      }
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      // Add your form submission logic here
      alert('Form submitted successfully!');
    });

    // Initialize
    updateButtons();
    updateProgress();
    
    isInitialized = true;
    return true;
  }

  // Try to initialize immediately
  if (!initializeQuizForm()) {
    // If form doesn't exist yet, observe for when it's added
    const quizApiSection = document.querySelector('.quiz-api-section');
    if (quizApiSection) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0) {
            // Check if form was added
            const form = document.getElementById('custom-quiz-form');
            if (form) {
              initializeQuizForm();
              observer.disconnect(); // Stop observing once initialized
            }
          }
        });
      });

      observer.observe(quizApiSection, {
        childList: true,
        subtree: true
      });
    }
  }
});